import React from "react";
import PropTypes from "prop-types";

function NcbiClinvarDescriptions({ diseaseNames }) {
  if (!diseaseNames) {
    return null;
  }
  const corrected = Array.from(new Set(diseaseNames));
  const [mainDisease, ...otherDiseases] = corrected;
  return (
    <div>
      <span className="tw-font-bold">{mainDisease}</span>
      {otherDiseases && otherDiseases.length ? (
        <span className="tw-px-2">({otherDiseases.join(", ")})</span>
      ) : null}
    </div>
  );
}

NcbiClinvarDescriptions.propTypes = {
  diseaseNames: PropTypes.arrayOf(PropTypes.string),
};

NcbiClinvarDescriptions.defaultProps = {
  diseaseNames: " ",
};

export default React.memo(NcbiClinvarDescriptions);
